import { Controller } from "@hotwired/stimulus"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// L'invio della bozza di DraftReview (components/readiness/DraftReview.js, 31a5bd1): onReviewFile.
// - «Carica la tua bozza per una revisione» apre la scelta del file (fileRef.current.click()); la scelta invia subito il
//   form multipart grant_id + file (Readiness::AnalisiController#create). Nessun file: nessun invio.
// - durante l'invio (revLoading): Loader2 e «Revisione in corso…» sul pulsante spento, l'attesa «Un valutatore AI sta
//   leggendo la tua bozza…» al posto del risultato. Riuscito: il pannello in attesa con il polling arriva dal server
//   (Turbo Stream, morph). Non riuscito: il toast del server (413 «File troppo grande (max 25MB).», 400 «Impossibile
//   estrarre testo…», formatApiErrorDetail || «Upload non riuscito») e il pannello torna com'era. In ogni caso l'input si
//   svuota (fileRef.current.value = ""), così lo stesso file si può scegliere di nuovo.
// - Nell'originale la richiesta continuava anche lasciando la scheda. Qui una visita Turbo fermerebbe l'invio del form:
//   finché la risposta non arriva le visite si fermano (lib/visite_trattenute.js, come dropzone_controller.js e
//   turbo/refresh_dopo_invio.js) e l'ultima riparte a fine invio (alla stessa pagina con action "replace": morph, il
//   polling della revisione resta). Una risposta d'errore che non è un Turbo Stream (500,
//   pagina del proxy) non diventa la pagina e, come un errore di rete, dà il toast «Upload non riuscito» qui.
const IN_CORSO = "Revisione in corso…"
const PULSANTE = "Carica la tua bozza per una revisione"
const ERRORE = "Upload non riuscito"
const STREAM = "text/vnd.turbo-stream.html"

export default class extends Controller {
  static targets = ["form", "input", "pulsante", "icona", "attesa", "testo", "caricamento", "risultato"]
  static values = { canEdit: Boolean }

  connect() {
    this.visite = new VisiteTrattenute()
  }

  disconnect() {
    this.visite.rilascia()
  }

  scegli() {
    if (!this.inVolo) this.inputTarget.click()
  }

  scelto() {
    if (!this.inVolo && this.inputTarget.files?.length) this.formTarget.requestSubmit()
  }

  inizio(event) {
    if (event.target !== this.formTarget) return
    this.inVolo = true
    this.visite.trattieni()
    this.inCorso(true)
  }

  // La risposta è arrivata: le visite possono ripartire. Un errore che non è un Turbo Stream non diventa la pagina.
  risposta(event) {
    if (event.target !== this.formTarget) return
    this.visite.lascia()
    const r = event.detail.fetchResponse
    if (r && !r.succeeded && !(r.contentType || "").startsWith(STREAM)) event.preventDefault()
  }

  fine(event) {
    if (event.target !== this.formTarget) return
    const url = this.visite.rilascia()
    this.inVolo = false
    if (this.hasInputTarget) this.inputTarget.value = ""
    const { success, fetchResponse } = event.detail
    const stream = (fetchResponse?.contentType || "").startsWith(STREAM)
    // riuscito con il Turbo Stream: il pannello in attesa lo rende il server
    if (!success || !stream) this.inCorso(false)
    if (!success && !stream) window.toast?.error?.(ERRORE)
    if (url) riparti(url)
  }

  inCorso(si) {
    this.attesaTargets.forEach((el) => el.classList.toggle("hidden", !si))
    this.iconaTargets.forEach((el) => el.classList.toggle("hidden", si))
    this.caricamentoTargets.forEach((el) => el.classList.toggle("hidden", !si))
    this.risultatoTargets.forEach((el) => el.classList.toggle("hidden", si))
    if (this.hasTestoTarget) this.testoTarget.textContent = si ? IN_CORSO : PULSANTE
    if (this.hasPulsanteTarget) this.pulsanteTarget.disabled = si || !this.canEditValue
  }
}
